<script>
import VClamp from 'vue-clamp';

import { SectionPostTypes } from '../../constants';

export default {
  name: 'CpSocialFeedCandidatePost',
  components: {
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpStateIcon: require('../icons/state-icon').default,
    WhiteHouseIcon: require('../icons/white-house').default,
    CpSocialShareDialog: require('../../dialogs/social-share').default,
    UsaFlagIcon: require('../icons/usa-flag').default,
    LikeActionButton: require('../actions/like-action-button').default,
    CpLikesProfiles: require('../../likes/likes-profiles').default,
    CpEndorsesProfiles: require('../../endorses/endorses-profiles').default,
    CpDialog: require('../../dialog').default,
    CpButtonLink: require('../../button-link').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    VClamp,
    EndorseActionButton: require('../../explore-campaigns/actions/endorse-action-button').default,
    CpEndorsesComment: require('../../endorses/endorses-comment').default,
    DonateActionButton: require('../../explore-campaigns/actions/donate-action-button').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpCardHeaderReactions: require('../../components/CardHeaderReactions').default,
    CpShowInteractionsCount: require('../../components/ShowInteractionsCount').default,
  },
  directives: {
    marginTop: require('../../directives/margins').marginTop,
  },
  data() {
    return {
      showLikesModal: false,
      showEndorsesModal: false,
      showEndorseCommentModal: false,
      comments_count: this.candidate.comments_count,
      endorsed: this.candidate.user_endorsed,
      endorses_count: this.candidate.endorses_count,
      type: SectionPostTypes.CANDIDATE,
    };
  },
  watch: {
    candidate(newResult) {
      this.endorses_count = newResult.endorses_count;
      this.comments_count = newResult.comments_count;
    },
  },
  props: {
    candidate: Object,
    explore: Boolean,
    forShare: Boolean, //Is shared in explore
    modal: Boolean,
    iconState: Boolean,
  },
  methods: {
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleEndorsesModal() {
      this.showEndorsesModal = !this.showEndorsesModal;
    },
    handleCountLikes(value) {
      if (value) {
        this.candidate.likes_count = this.candidate.likes_count + 1;
      } else {
        this.candidate.likes_count = this.candidate.likes_count - 1;
      }
    },
    closeEndorseCommentModal() {
      this.showEndorseCommentModal = false;
    },
    setCount(type) {
      if (type == 'endorse') {
        this.showEndorseCommentModal = true;
        this.endorses_count++;
      } else {
        this.comments_count++;
      }
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
    profile(slug) {
      if (slug) {
        return '/profile/' + slug;
      }
      return null;
    },
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
    election() {
      const currentElection = this.candidate.current_election;
      return {
        state: currentElection.state,
        seat: currentElection.seat,
        type: currentElection.fecyear + ' ' + currentElection.type.toUpperCase() + ' ELECTION',
      };
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <div v-if="candidate.last_activity && !forShare">
      <CpCardHeaderReactions :post="candidate.last_activity" />

      <p class="heading-3" v-if="candidate.last_activity.description">{{ '"' + candidate.last_activity.description + '"' }}</p>
      <hr class="search-results__tick" />
    </div>

    <cp-grid>
      <cp-grid-item :span="$root.isMobile ? 12 : 6">
        <img :src="candidate.large_img" alt="" width="100%" style="height: 380px; object-fit: cover; object-position: center top" />
      </cp-grid-item>
      <cp-grid-item :span="$root.isMobile ? 12 : 6">
        <div>
          <h1 class="title-1" style="text-align: center; margin: 10px; font-size: 40px">{{ candidate.name }}</h1>
          <h2 v-if="election.seat != 'President'" class="heading-4" style="text-align: center; font-size: 30px; margin: 0px">
            {{ election.state + ' ' + election.seat }}
          </h2>
          <h2 v-else class="heading-4" style="text-align: center; font-size: 30px; margin: 0px">{{ election.seat }}</h2>
          <h3 class="heading-5" style="text-align: center; font-size: 18px; margin: 0px">{{ election.type }}</h3>
          <div v-if="iconState">
            <cp-state-icon style="margin: 0px" v-if="!!election.state" :american-state="election.state" :color="true" />
          </div>
        </div>
      </cp-grid-item>
    </cp-grid>

    <a :href="candidate.permalink" style="font-size: 20px; margin-top: 20px" class="heading-4">View Candidate</a>

    <div v-if="!forShare" style="margin-top: 10px !important">
      <CpShowInteractionsCount
        :type="type"
        :id="candidate.id"
        :likesCount="candidate.likes_count"
        :commentsCount="comments_count"
        :endorsesCount="endorses_count"
        :handleLikesModal="handleLikesModal"
        :handleEndorsesModal="handleEndorsesModal"
      />
    </div>

    <cp-dialog v-if="showLikesModal">
      <cp-likes-profiles :count-likes="candidate.likes_count" :id="candidate.id" :type="'candidate'" @close="handleLikesModal"></cp-likes-profiles>
    </cp-dialog>

    <cp-dialog v-if="showEndorsesModal && !forShare">
      <cp-endorses-profiles :count-endorses="endorses_count" :id="candidate.id" :type="'candidate'" @close="handleEndorsesModal"></cp-endorses-profiles>
    </cp-dialog>

    <div v-if="!forShare" class="social-feed-post-actions">
      <div class="post-action-button like">
        <like-action-button type="candidate" :id="candidate.id" :liked="candidate.liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button like">
        <endorse-action-button
          :id="candidate.id"
          :onSuccess="setCount"
          :endorsed="this.endorsed ? this.endorsed : this.candidate.user_endorsed"
          :type="'candidate'"
          :modal="modal"
        />
      </div>
      <div v-if="candidate.contribution_link" class="post-action-button like">
        <donate-action-button :link="candidate.contribution_link" :type="'candidate'" />
      </div>
      <div class="post-action-button comment">
        <comment-action-button :type="type" :id="candidate.id" />
      </div>
      <div class="post-action-button share">
        <cp-social-share-dialog
          class="feed"
          :allow-share-feed="true"
          share-category="Candidate"
          :type="'candidate'"
          :post="candidate"
          share-button-class="button--noborder"
          :url="candidate.permalink"
          title="Candidate found via CrowdBlue, the  Social Network For Politics"
          :description="`Wanted to share this candidate I found on CrowdBlue, the Social Network for Politics.`"
          :quote="'Support ' + candidate.name + ' on CrowdBlue'"
          hashtags="crowdBlue,politics,crowdfunding"
          twitter-user="crowdblue"
          :explore="explore"
        ></cp-social-share-dialog>
      </div>
    </div>

    <cp-comments-post v-show="!forShare" :id="candidate.id" :type="type" :setCount="setCommentsCount"> </cp-comments-post>
    <cp-dialog v-if="showEndorseCommentModal">
      <cp-endorses-comment :result="candidate" @close="closeEndorseCommentModal" :setCount="setCount" :type="type"> </cp-endorses-comment>
    </cp-dialog>
  </div>
</template>

<style>
.candidates-box {
  width: 95%;
  text-align: center;
}
.candidate-profile {
  display: block;
}
.content-1 {
  margin-left: 5px;
}
.candidate-name {
  color: white;
  font-size: 1.17em;
  font-weight: bold;
  margin: 10px 0;
}
.more-candidates {
  color: white;
  margin: 0;
}
.search-results__tick {
  color: #cacaca;
  width: 50px;
}
</style>
